import React, { useEffect, useRef } from "react";
import './Game.css';

const Game = ({thumbnail, title, description , romPath, setRom}) => {
    const gameCard = useRef();
    useEffect(() => {
       gameCard.current.onclick = () => {
           
           setRom(romPath);
       } 
    }, [romPath, setRom])
    return (
        <div className = {"Game__Card"} ref={gameCard}>
            <div className = {"Game__Thumbnail"}>
                <img src = {thumbnail}/>
            </div>
            <div className = {"Game__Description"} >
                <h2 className = {"Game__Title"}> {title} </h2>
                <div className = {"Game__Description__Text"}>
                    {description}
                </div>
            </div>
        </div>
  );
};

export default Game;